import { Injectable } from '@angular/core';
import { ApiService } from '@app/core/services/api.service';
import { IUser } from '@common/models/IUser';
import { Observable, shareReplay, tap } from 'rxjs';
import { UserResolver } from '@app/user.resolver';

@Injectable({
  providedIn: 'root'
})
export class UserProfileService {

  private me$: Observable<IUser> | null = null;

  constructor(private apiService: ApiService, private userResolver: UserResolver) {
  }

  getMe(): Observable<IUser> {
    if (!this.me$) {
      this.me$ = this.apiService.get<IUser>(`User/Me`).pipe(shareReplay(1));
    }
    return this.me$;
  }

  clearMeCache(): void {
    this.me$ = null;
  }

  getUserByEmail(email: string): Observable<IUser>
  {
    return this.userResolver.getUserByEmail(email);
  }
  updateUser(user: IUser): Observable<IUser> {
    return this.apiService.post(`User`, user).pipe(tap(() => this.clearMeCache()));
  }

  bulkRefreshUsers(): Observable<string> {
    return this.apiService.get(`User/BulkRefresh`);
  }

  syncUser(objectId: string): Observable<IUser> {
    return this.apiService.get(`User/Refresh/${objectId}`);
  }
}
